import { useCookiesContext } from '../../contexts/CookiesContext'
import { onReadNotification } from '../../helpers/on-read-notifications'
import { notificationTitlesTranslates, notificationMessges } from '@revbox/localization'

function NotificationListItem({ item, key, notificationPath }) {
    const { getLanguageAbbr } = useCookiesContext();
    const language = getLanguageAbbr();
    const title = item.title ? notificationTitlesTranslates[language][item.type] : item.text[0];

    return (
        <li
            className="list-group-item"
            key={key}
            style={item.status === 'read' ? { opacity: 0.35 } : {}}
            onClick={() => onReadNotification(item.id, item.link, notificationPath)}
        >
            {item.icon_url ? (
                <div
                    className={item.status === 'unread' ? 'avatar online' : 'avatar'}
                    style={{
                        backgroundImage: 'url(' + item.icon_url + ')',
                        backgroundPosition: 'center',
                        backgroundSize: 'contain'
                    }}
                />
            ) : (
                <div className={item.status === 'unread' ? 'avatar online' : 'avatar'}>
                    <span className="avatar-initial">{title[0]}</span>
                </div>
            )}
            <div className="list-group-body">
                <p>{title}</p>
                <span>{item.date}</span>
            </div>
        </li>
    )
}

function NotificationList({ notifications, notificationPath }) {
    const { getLanguageAbbr } = useCookiesContext();
    const language = getLanguageAbbr();
    const message = notificationMessges[language].no_notifications;
    return (
        <ul className="list-group">
            {notifications.length > 0 ? (
                notifications.map((item, key) => <NotificationListItem item={item} key={key} notificationPath={notificationPath} />)
            ) : (
                <li className="list-group-item">{message}</li>
            )}
        </ul>
    )
}

export default NotificationList
